export default __webpack_public_path__ + "static/media/waifu-pepe.52265fc8.jpeg";